import { useEffect, useRef, useState } from "react";
import PunchMatteImage from "./PunchMatteImage";
import s from "./createAppLanding.module.css";

const STORIES = [
  {
    id: "home",
    title: "Сводка",
    text: "Кто записан, ближайшие занятия, ответы «приду».",
    src: "/landing/mock-owner-home.png",
    side: "right",
  },
  {
    id: "calendar",
    title: "Календарь",
    text: "Расписание по залам и тренерам. Новое занятие за минуту.",
    src: "/landing/mock-owner-calendar.png",
    side: "left",
  },
  {
    id: "clients",
    title: "Клиенты",
    text: "База, группы, ссылка и QR на регистрацию.",
    src: "/landing/mock-owner-clients.png",
    side: "right",
  },
  {
    id: "journal",
    title: "Журнал",
    text: "Перекличка и списание с абонемента с телефона.",
    src: "/landing/mock-owner-journal.png",
    side: "left",
  },
  {
    id: "finance",
    title: "Финансы",
    text: "Платежи, выручка, должники.",
    src: "/landing/mock-owner-finance.png",
    side: "right",
  },
];

function StoryRow({ story }) {
  const ref = useRef(null);
  const [on, setOn] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const mobile = window.matchMedia("(max-width: 900px)").matches;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setOn(true);
      },
      {
        threshold: mobile ? 0.12 : 0.28,
        rootMargin: mobile ? "0px 0px -6% 0px" : "0px 0px -8% 0px",
      },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const left = story.side === "left";

  return (
    <article
      ref={ref}
      className={`${s.storyRow} ${left ? s.storyRowLeft : ""} ${
        on ? s.storyRowIn : ""
      }`}
    >
      <div className={s.storyCopy}>
        <h3>{story.title}</h3>
        <p>{story.text}</p>
      </div>
      <div className={s.storyPhoneWrap}>
        <PunchMatteImage
          src={story.src}
          alt={story.title}
          className={s.storyPhone}
        />
      </div>
    </article>
  );
}

export default function OwnersNeed() {
  return (
    <section id="owner" className={s.storySection} aria-label="Кабинет клуба">
      <div className={s.storyHead}>
        <p className={s.storyEyebrow}>Кабинет клуба</p>
        <h2 className={s.storyTitle}>Всё, что нужно владельцу</h2>
      </div>
      <div className={s.storyStack}>
        {STORIES.map((story) => (
          <StoryRow key={story.id} story={story} />
        ))}
      </div>
    </section>
  );
}
